import { useParams, useNavigate, useLocation } from "react-router";
import PageMeta from "../../components/common/PageMeta";
import PageBreadcrumb from "../../components/common/PageBreadCrumb";
import EditCheckoutBuilderForm from "../../components/form/checkout-builder/EditCheckoutBuilderForm";

export default function EditCheckoutBuilder() {
    const { productId, checkoutId } = useParams<{ productId: string, checkoutId: string }>();
    const navigate = useNavigate();
    const location = useLocation();
    
    // Obter offerId dos parâmetros de consulta
    const queryParams = new URLSearchParams(location.search);
    const offerId = queryParams.get('offerId');

    // Função para voltar à página anterior
    const handleGoBack = () => {
        if (productId) {
            navigate(`/products/edit/${productId}?tab=checkout`);
        } else {
            navigate('/products');
        }
    };

    // Redirecionar se não tiver productId, checkoutId ou offerId
    if (!productId || !checkoutId || !offerId) {
        return (
            <div className="container mx-auto px-4 md:px-6 py-8">
                <div className="bg-red-50 dark:bg-red-900/10 text-red-600 dark:text-red-400 p-6 rounded-lg">
                    <h2 className="text-xl font-semibold mb-2">Informações incompletas</h2>
                    <p>
                        {!productId && "O ID do produto não foi fornecido."}
                        {!productId && (!checkoutId || !offerId) && " "}
                        {!checkoutId && "O ID do checkout não foi fornecido."}
                        {(!productId || !checkoutId) && !offerId && " "}
                        {!offerId && "O ID da oferta não foi fornecido."}
                    </p>
                    <button 
                        className="mt-4 bg-primary text-white px-4 py-2 rounded-md"
                        onClick={handleGoBack}
                    >
                        Voltar
                    </button>
                </div>
            </div>
        );
    }

    return (
        <>
            <PageMeta
                title="Sellyo - Editar Checkout"
                description="Editar checkout para o produto"
            />
            <PageBreadcrumb
                pageTitle="Editar Checkout"
                showBackButton={true}
                onBack={handleGoBack}
            />

            <div className="container mx-auto px-4 md:px-6">
                <EditCheckoutBuilderForm
                    productId={productId}
                    checkoutId={checkoutId}
                    offerId={offerId}
                    onSuccess={() => {
                        // Redirecionar para a página de edição do produto na aba de checkouts
                        navigate(`/products/edit/${productId}?tab=checkout`);
                    }}
                    onError={(error) => {
                        console.error("Erro ao editar checkout:", error);
                    }}
                />
            </div>
        </>
    );
}